export default class OCECRatio {
  static GROUPS = [{
    group: [{
      factorId: '6400',
      newId: 'tOc'
    }, {
      factorId: '6401',
      newId: 'tEc'
    }],
    ratioId: 'tRatio',
    ratioName: 'Thermal OC/Thermal EC'
  }, {
    group: [{
      factorId: '6402',
      newId: 'oOc'
    }, {
      factorId: '6403',
      newId: 'oEc'
    }],
    ratioId: 'oRatio',
    ratioName: 'OptOC/OptEC'
  }]

  static OC_EC_RATIO_UNIT = 'OC/EC'

  static SPLIT_TIME = {
    id: 'splitTime',
    factorId: 'splitTime',
    name: 'Split time',
    displayUnit: 's'
  }
}



// WEBPACK FOOTER //
// ./src/model/OCECRatio.js